import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {ProCampo} from "../types/ProCampo.type";
import {ProAreaVariavel} from "../types/ProAreaVariavel.type";

@Injectable({
  providedIn: 'root'
})
export class ProareaService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAreaComVariaveis() {
    return this.httpClient.get<ProAreaVariavel[]>(`${this.configService.getApiUrlRoot()}/proanalise/areas/areas-variaveis`);
  }
}
